import { Box, Center, Flex, Heading, HStack, Spinner } from "@chakra-ui/react";
import moment from "moment";
import React, { useMemo } from "react";
import { useEvents } from "../../data/events.api";
import EventCard from "./EventCard";

type Props = {};

const EventsSpotlight = (props: Props) => {
  const { data, isLoading, isError } = useEvents();

  return (
    <Box p={5} pt={0}>
      <Heading size="xs" mb={4}>
        What's happening on campus?
      </Heading>

      {isLoading ? (
        <Center p={5} w="full">
          <Spinner />
        </Center>
      ) : isError ? null : data ? (
        <Flex
          gap={3}
          overflowX="auto"
          css={{
            "&::-webkit-scrollbar": {
              width: "0px",
              height: "0px",
            },
            overflow: "-moz-scrollbars-none;",
          }}
        >
          {data.map((e) => (
            <EventCard key={e.eventId} event={e} />
          ))}
        </Flex>
      ) : null}
    </Box>
  );
};

export default EventsSpotlight;
